export const LANDING = {
  navCta: "landing-nav-cta",
  langToggle: "landing-lang-toggle",
  heroCta: "landing-hero-cta",
  heroCta2: "landing-hero-cta2",
  liveWidget: "landing-live-widget",
  widgetToggle: "landing-widget-toggle",
  pricingCta: "landing-pricing-cta",
  finalCta: "landing-final-cta",
  faqItem: "landing-faq",
};
